<template>
    <div class="app" id="app">
        <app-swiper></app-swiper>
        <app-header></app-header>
        <app-lang></app-lang>
        <div class="line"></div>
        <app-footer></app-footer>
    </div>
</template>


<script>
    export default {

    }
</script>


<style lang="scss">
    :root {
        --dark-gray: #21282d;
        --rasp: #ae0e47;
        --red: #f82b2b;
    }

    *, *:before, *:after {
        box-sizing: border-box;
    }

    html, body {
        height: 100vh;
        overflow: hidden;
        font-size: 15px;
    }

    body {
        margin: 0;
        font-family: 'Montserrat', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #fff;
    }

    .app {
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .line {
        width: 6px;

        background-color: var(--rasp);

        position: absolute;
        top: 50%;
        left: 3.5rem;
        z-index: 10;

        transform: translateY(-40%);

        animation: line-grow .8s ease-in-out forwards 1.5s;

        @media (max-width: 991px) {
            transform: translateY(-50%);
        }

        @media (max-width: 767px) {
            left: 1.5rem;
        }
    }

    .text-red {
        color: var(--red);
    }

    .hide {
        display: none;
    }

    @keyframes line-grow {
        0% {
            height: 0;
        }

        100% {
            height: 100%;
        }
    }

    @media (max-width: 991px) {
        .hide-tablet {
            display: none;
        }
    }

    @media (max-width: 767px) {
        .hide-mobile {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue